import { render, staticRenderFns } from "./dialChangePrice.vue?vue&type=template&id=1ed9f93a&"
import script from "./dialChangePrice.vue?vue&type=script&lang=js&"
export * from "./dialChangePrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports